import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import { initSentry } from '@shared/js/sentry';
// base
import router from '@js/analysis/router';
import store from '@js/store';
import Event from '@videotools/js/api/entities/Event';
import { actions as sharedUserActions } from '@legacy/js/store/user';

// mixins and directives
import * as transMixin from '@js/mixins/transHelpers';
import directives from '@js/directives';

// extra
import $I18n from '@js/i18n';

Vue.prototype.$I18n = $I18n;
window.openModals = [];

const init = async(data) => {
	store.dispatch('app/setAppTypeMoments');

	if (window.$arenaConfig.loadArenaProfile) {
		store.dispatch(`sharedUser/${sharedUserActions.LOAD_PROFILE}`);
	} else {
		store.dispatch(`sharedUser/${sharedUserActions.SET_INITIALIZED}`);
	}

	// handle event
	if (data.event) {
		const wrappedEvent = new Event(data.event);
		await store.dispatch('event/setEvent', wrappedEvent);
		await store.dispatch('event/loadEventTags', wrappedEvent.id);
	}

	// register directives and mixins
	Vue.use(transMixin);

	for (const directive of directives) {
		directive.register();
	}

	// register plugins
	Vue.use(Vue2TouchEvents);

	initSentry('Moments');

	return new Vue({
		el: '#moments',
		store,
		router,
	});
};

export { init };
